import { useNavigate } from 'react-router-dom';
import { useResultJSON } from './ResultJSON'; // Assuming this is your custom hook to fetch data
import { Card, CardContent, Typography, CardActionArea } from '@mui/material';
import { Grid, Box } from '@mui/material';


interface FIPOKLocalizedString {
    [languageCode: string]: string;
}


interface FIPOKSurveyObject {
    surveySymbolicID: string,
    title: FIPOKLocalizedString,
    surveyJsonPath: string
}


export const FIPOKSurveys = () => {
    const jsonData = useResultJSON(); // Assuming this hook fetches JSON data from the backend
    // const bucketBaseURL = useResultJSONBucketBaseURL();
    const navigate = useNavigate();


    if (jsonData === null) {
        return <div></div>;
    };

    const surveys = jsonData as FIPOKSurveyObject[];


    const handleCardClick = (a_gameName: string) => {
        navigate(`/survey/${a_gameName}`);
    };

    if (jsonData.length === 0) {
        // no games in this section, return empty div
        return (<div></div>)
            ;
    }

    return (
        <div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '24px', padding: '16px' }}>

                <Box display="flex" alignItems="center" style={{ height: '100px' }}>
                    {/* <IconButton size="large">
						<img src={games.iconURL} alt={games.categoryName['hu']} style={{ width: '60px', height: '60px' }} />
					</IconButton> */}
                    <Box mx={1} flexGrow={1} textAlign="center">
                        <Typography variant="h3">Elérhető kérdőívek:</Typography>
                    </Box>
                </Box>

                <Grid container spacing={2}>
                    {surveys.map(survey => (
                        <Grid item xs={12} sm={6} md={4} lg={3} xl={2} key={survey.surveySymbolicID + '_grid_item'}>
                            <Card key={survey.surveySymbolicID} style={{ width: '90%', height: '100%' }} onClick={() => handleCardClick(survey.surveyJsonPath)}>
                                <CardActionArea>
                                    <CardContent>
                                        {/* <CardMedia
                                        component="img"
                                        width="50%"
                                        image={game.iconURL}
                                        alt={game.title.en}
                                    /> */}
                                        <Typography variant="h6" component="div" textAlign={'center'}>
                                            {survey.title.hu}
                                        </Typography>
                                        {/* <Typography variant="body1" component="div" textAlign={'center'}>
                                        {survey.description_short && survey.description_short['hu']}
                                    </Typography> */}
                                    </CardContent>
                                </CardActionArea>
                            </Card>
                        </Grid>
                    ))}

                </Grid>


            </div>

        </div>
    );
};

export default FIPOKSurveys;
